// extracted by css-extract-rspack-plugin
export default {"howItWorksContainer":"CkFQbjO94UVFoeZl","howItWorksContent":"BnBIZxDjOo8eivKc","cardContainer":"lwrqyPkxfwQ8hh6z","companyLogo":"MGyex59E3wYnBQuc"};